import { render, staticRenderFns } from "./product-detail-info.vue?vue&type=template&id=fb4c68fc&scoped=true&"
import script from "./product-detail-info.vue?vue&type=script&lang=js&"
export * from "./product-detail-info.vue?vue&type=script&lang=js&"
import style0 from "./product-detail-info.vue?vue&type=style&index=0&id=fb4c68fc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb4c68fc",
  null
  
)

export default component.exports